import { makeActionCreator } from '../../../utilities'
import { singleSelectPageConstants } from './singleSelectPage.constants'

export const setIsScrollEnd = makeActionCreator(singleSelectPageConstants.IS_SCROLL_END, 'isScrollEnd')
export const setOptions = makeActionCreator(singleSelectPageConstants.SET_OPTIONS, 'options')
export const setChunkedOptions = makeActionCreator(singleSelectPageConstants.SET_CHUNKED_OPTIONS, 'chunkedOptions')
export const updateChunkedOptions = makeActionCreator(singleSelectPageConstants.UPDATE_CHUNKED_OPTIONS)
export const setCommonOptions = makeActionCreator(singleSelectPageConstants.SET_COMMON_OPTIONS, 'commonOptions')
export const setFilteredCommonOptions = makeActionCreator(
  singleSelectPageConstants.SET_FILTERED_COMMON_OPTIONS,
  'filteredCommonOptions'
)
